import PropTypes from 'prop-types';
import React from 'react';
import { applyRouterMiddleware, Router, Route, IndexRedirect, Redirect, browserHistory} from 'react-router';
import useScroll from 'react-router-scroll/lib/useScroll';
import LaunchApp from 'launch/components/LaunchApp';
import loadRoute from 'launch/components/loadRoute';
import { updateDraftStep } from 'launch/actions/designBriefActions';

class LaunchRouter extends React.Component {
    constructor(props) {
        super(props);

        this.onEnter = this.onEnter.bind(this);
    }

    onEnter(nextState) {
        this.context.executeAction(updateDraftStep, {
            step: nextState.routes[1].path,
            params: nextState.params
        });
    }

    render() {
        return (
            <Router
                history={browserHistory}
                render={applyRouterMiddleware(useScroll())}>

                <Route path="/launch/product-packaging-design/:draft_hash/visualbrief" component={LaunchApp}>
                    <Route
                        path="package-type"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefPackageType'], done))} />
                    <Route
                        path="designs"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), { withStyleAssessment: false })} />
                    <Route
                        path="colors"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))} />

                    <IndexRedirect to="package-type" />
                    <Redirect from="*" to="package-type" />
                </Route>

                <Route path="/launch/book-cover-design/:draft_hash/visualbrief" component={LaunchApp}>
                    <Route
                        path="book-type"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefBookType'], done))} />
                    <Route
                        path="designs"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), { withStyleAssessment: false })} />
                    <Route
                        path="colors"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))} />

                    <IndexRedirect to="book-type" />
                    <Redirect from="*" to="book-type" />
                </Route>

                <Route path="/launch/product-label-design/:draft_hash/visualbrief" component={LaunchApp}>
                    <Route
                        path="designs"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), { withStyleAssessment: false })}  />
                    <Route
                        path="attributes"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleAttributes'], done))} />
                    <Route
                        path="colors"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))} />
                    <Route
                        path="brief"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/ProductLabelDesignBrief'], done))} />

                    <IndexRedirect to="designs"/>
                    <Redirect from="*" to="designs"/>
                </Route>

                <Route path="/launch/:category/:draft_hash/visualbrief" component={LaunchApp}>
                    <Route
                        path="designs"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleSelector'], done), { withStyleAssessment: true })}  />
                    <Route
                        path="attributes"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/containers/BriefStyleAttributesWithEmailCollection'], done))} />
                    <Route
                        path="colors"
                        onEnter={this.onEnter}
                        component={loadRoute(done => require(['launch/components/BriefStyleColors'], done))} />

                    <IndexRedirect to="designs"/>
                    <Redirect from="*" to="designs"/>
                </Route>

            </Router>
        );
    }
}

LaunchRouter.contextTypes = {
    executeAction: PropTypes.func
};

export default LaunchRouter;



// WEBPACK FOOTER //
// ./js/launch/routes/LaunchRouter.jsx